export default __webpack_public_path__ + "static/grande-epopee-95b1db3387190a32b854bb7f6e22a224.png";